/* eslint-disable max-len */
import React from 'react';

interface ITelegramProps {
    color?: string;
}

const Telegram: React.FC<ITelegramProps> = ({color='#899696'}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="16"
                height="16"
                rx="8" fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62167 7.91547C5.95383 6.89938 7.50897 6.22952 8.28709 5.90587C10.5088 4.9818 10.9704 4.82128 11.2713 4.81597C11.3375 4.81481 11.4855 4.83121 11.5813 4.90899C11.6623 4.97466 11.6845 5.06337 11.6952 5.12563C11.7058 5.1879 11.7191 5.32974 11.7086 5.44057C11.5882 6.70556 11.0672 9.77535 10.8022 11.1922C10.6901 11.7917 10.4692 11.9927 10.2555 12.0123C9.79089 12.0551 9.43812 11.7053 8.98815 11.4104C8.28405 10.9488 7.88627 10.6615 7.20282 10.2111C6.41297 9.69061 6.92499 9.40454 7.37513 8.93701C7.49293 8.81466 9.53986 6.95282 9.57948 6.78392C9.58443 6.7628 9.58903 6.68406 9.54225 6.64248C9.49548 6.60091 9.42644 6.61512 9.37662 6.62643C9.306 6.64246 8.18118 7.38592 6.00217 8.85681C5.68289 9.07605 5.3937 9.18287 5.1346 9.17727C4.84896 9.1711 4.2995 9.01577 3.89103 8.88299C3.39003 8.72014 2.99185 8.63403 3.02652 8.35745C3.04458 8.2134 3.24296 8.06607 3.62167 7.91547Z"
                fill="white"
            />
        </svg>
    );
};

export default Telegram;